export default "__VITE_ASSET__CkO9vlWB__"